export const config: { apiBaseURL:string, tokenUrl:string } =
{
    tokenUrl: "/token.php",
    apiBaseURL: "/api"
};
